// Joya Headquarter — shift planning, staffing rules, labor cost, payroll checks (English).
// Same keys in staffing.he.js.
export default {
  // ---- staffing plans
  'joya.staff.sub': 'A weekly staffing proposal from the expected demand of each shift. Ask, edit and approve.',
  'joya.staff.tabPlans': 'Plans',
  'joya.staff.tabForecast': 'Demand forecast',
  'joya.staff.proposeTitle': 'Proposal for a week',
  'joya.staff.proposeHelp': 'The system looks at POS activity in past weeks, forecasts the demand of each shift and calculates how many staff are needed under the rules.',
  'joya.staff.proposeFor': 'The proposal is for:',
  'joya.staff.week': 'Week',
  'joya.staff.weekHint': 'Any day of the week works — the week starts on Sunday.',
  'joya.staff.propose': 'Make a proposal',
  'joya.staff.proposeAgain': 'New proposal from scratch',
  'joya.staff.noPlans': 'No staffing plans yet.',
  'joya.staff.weekOf': 'Week of',
  'joya.staff.peopleShifts': 'Staff slots in the week',
  'joya.staff.proposedBy': 'Proposed by',
  'joya.staff.approvedBy': 'Approved by',
  'joya.staff.unitsHelpTitle': 'What do the demand units mean?',
  'joya.staff.forecastHelp': 'The forecast is the median of the same weekday in past weeks. Days with no data are left out — they are not counted as zero.',
  'joya.staff.forecastMethod': 'median of the same weekday over the previous {weeks} weeks; fewer than {min} days with data = low confidence',
  'joya.staff.noShifts': 'This location has no shifts yet (Staffing rules → Shifts).',
  'joya.staff.nDays_one': 'from 1 day',
  'joya.staff.nDays_other': 'from {count} days',
  'joya.staff.pastDates': 'Dates checked',
  'joya.staff.histLine': '{checks} checks · diners:',
  'joya.staff.missingNotZero': 'A date with no sales (the restaurant was closed) is not used for learning.',

  // ---- one plan
  'joya.staff.tabWeek': 'The week',
  'joya.staff.tabActual': 'Planned vs actual',
  'joya.staff.tabProposal': 'Original proposal',
  'joya.staff.tabLog': 'Edit log',
  'joya.staff.proposedByAt': 'Proposed: {who} · {when}',
  'joya.staff.approvedByAt': 'Approved: {who} · {when}',
  'joya.staff.rejectedByAt': 'Rejected: {who} · {when}',
  'joya.staff.reopen': 'Reopen for editing',
  'joya.staff.warningsTitle': 'Please note:',
  'joya.staff.warn.CANNOT_COMPUTE': '{role}: cannot be calculated — no demand data ({units}) and no minimum. Add it by hand.',
  'joya.staff.warn.PEAK_DEMAND_UNKNOWN': '{role}: the peak extra was not calculated — data missing ({units}).',
  'joya.staff.warn.MIN_ABOVE_MAX': '{role}: the minimum ({min}) is above the maximum ({max}) — check the rules.',
  'joya.staff.warn.ZERO_BELOW_MANDATORY': '{role}: the calculation gave 0, but there is a mandatory minimum of {min}.',
  'joya.staff.violationsTitle': 'The plan is under a mandatory minimum:',
  'joya.staff.minByAdmin': 'Mandatory minimums are set by chain management in the staffing rules. Editing a plan cannot go below them.',
  'joya.staff.exportCsv': '⬇ File for Tabit (CSV)',
  'joya.staff.exportNote': 'No automatic connection to Tabit — import or copy this file by hand.',
  'joya.staff.closedDay': 'No shift on this day.',
  'joya.staff.people_one': '1 person',
  'joya.staff.people_other': '{count} people',
  'joya.staff.peak': 'peak hours',
  'joya.staff.added': 'added by hand',
  'joya.staff.min': 'min {n}',
  'joya.staff.proposedWas': 'Original proposal: {n}',
  'joya.staff.learned': 'Learned from your edits: {delta} ({seen} of the last {window} weeks). Rule result: {rule}',
  'joya.staff.baseline': 'Earlier staffing (example): {n}',
  'joya.staff.addRole': 'Add a role',
  'joya.staff.why': 'Why this number?',
  'joya.staff.demandUsed': 'Demand used',
  'joya.staff.forecastValue': 'Expected value',
  'joya.staff.basedOn': 'Based on',
  'joya.staff.confidence': 'Confidence',
  'joya.staff.note.DEMAND_UNKNOWN': 'No demand data ({unit}) — the demand rule was not calculated.',
  'joya.staff.note.MIN_ONLY_DEMAND_UNKNOWN': 'Demand is not known, so only the minimum is proposed.',
  'joya.staff.note.FROM_BASELINE': 'No rule for this role — the number comes from earlier staffing.',
  'joya.staff.addedByManager': 'This line was added by hand — the system did not calculate it.',
  'joya.staff.minExplain': 'Mandatory minimum in this shift: {n}.',
  'joya.staff.headcount': 'Headcount',
  'joya.staff.start': 'Start',
  'joya.staff.end': 'End',
  'joya.staff.role': 'Role',
  'joya.staff.removeLine': 'Remove line',
  'joya.staff.approveTitle': 'Approve the plan',
  'joya.staff.approveHelp': 'After approval the plan is saved as it is. The original proposal is kept next to it.',
  'joya.staff.rejectTitle': 'Reject the plan',
  'joya.staff.ex1': 'Why do we need three cooks on Thursday morning?',
  'joya.staff.ex2': 'Show demand on recent Thursdays',
  'joya.staff.ex3': 'Add a waiter starting at noon on Thursday',
  'joya.staff.ex4': 'Recalculate using two runners above the threshold I defined',
  'joya.staff.weekNotStarted': 'The week has not started — there is no actual data yet.',
  'joya.staff.hoursByRole': 'Hours by role',
  'joya.staff.roleUnknown': 'role not known',
  'joya.staff.rowsMissingHours_one': '1 row without hours',
  'joya.staff.rowsMissingHours_other': '{count} rows without hours',
  'joya.staff.plannedArrowActual': 'planned → actual',
  'joya.staff.forecastArrowActual': 'Each line: expected → actual',
  'joya.staff.noActualData': 'No POS data for this day',
  'joya.staff.plannedPeopleHours': 'Planned: people · hours',
  'joya.staff.proposalHelp': 'The proposal as the system made it, before any edit. It never changes.',
  'joya.staff.noEdits': 'No changes yet.',
  'joya.staff.via': 'Via',
  'joya.staff.via.UI': 'the screen',
  'joya.staff.via.CHAT': 'chat with headquarters',
  'joya.staff.beforeAfter': 'Before / after',
  'joya.staff.action.ADD': 'Added',
  'joya.staff.action.SET': 'Changed',
  'joya.staff.action.REMOVE': 'Removed',
  'joya.staff.action.APPROVE': 'Approved',
  'joya.staff.action.REJECT': 'Rejected',
  'joya.staff.action.REOPEN': 'Reopened',

  // ---- rules
  'joya.rules.tabRules': 'Rules',
  'joya.rules.tabShifts': 'Shifts',
  'joya.rules.tabBaseline': 'Earlier staffing',
  'joya.rules.tabRoles': 'Roles',
  'joya.rules.intro': 'The most specific rule wins: location + shift + days, then location, then all locations. A ratio rule and a steps rule together → the larger number. Editing a weekly plan never changes these rules. Chain-wide and mandatory rules: chain management only.',
  'joya.rules.showingFirst': 'Showing the first location. Choose a location at the top of the page.',
  'joya.rules.newRule': 'New rule',
  'joya.rules.editRule': 'Edit rule',
  'joya.rules.none': 'No rules yet.',
  'joya.rules.s.FIXED': 'exactly {count}',
  'joya.rules.s.MIN': 'at least {count}',
  'joya.rules.s.MAX': 'at most {count}',
  'joya.rules.s.RATIO': '1 per {per} ({unit})',
  'joya.rules.s.STEPS': 'by steps of {unit}: {steps}',
  'joya.rules.s.step': 'above {above} → {count}',
  'joya.rules.s.PEAK_EXTRA': '{count} more from {start} to {end} when {unit} is above {above}',
  'joya.rules.allLocations': 'all locations',
  'joya.rules.allShifts': 'all shifts',
  'joya.rules.allDays': 'all days',
  'joya.rules.thisLocation': 'the location',
  'joya.rules.thisShift': 'the shift',
  'joya.rules.mandatory': 'mandatory',
  'joya.rules.chainWide': 'whole chain',
  'joya.rules.locationRule': 'location rule',
  'joya.rules.inactive': 'inactive',
  'joya.rules.adminOnly': 'Only chain management can change this',
  'joya.rules.confirmDelete': 'Delete this rule?',
  'joya.rules.type': 'Rule type',
  'joya.rules.type.FIXED': 'Fixed number',
  'joya.rules.type.MIN': 'Minimum',
  'joya.rules.type.MAX': 'Maximum',
  'joya.rules.type.RATIO': 'Ratio to demand',
  'joya.rules.type.STEPS': 'Demand steps',
  'joya.rules.type.PEAK_EXTRA': 'Extra at peak hours',
  'joya.rules.typeHelp.FIXED': 'Always the same number, whatever the demand (e.g. one checker in the morning).',
  'joya.rules.typeHelp.MIN': 'Never fewer than this. A mandatory minimum cannot be lowered by an edit.',
  'joya.rules.typeHelp.MAX': 'Never more than this.',
  'joya.rules.typeHelp.RATIO': 'One person per amount of demand, rounded up (e.g. a waiter per 30 diners).',
  'joya.rules.typeHelp.STEPS': 'Headcount by ranges: when demand is above a value — this many people.',
  'joya.rules.typeHelp.PEAK_EXTRA': 'Extra people for certain hours, only when demand is above a threshold.',
  'joya.rules.unit': 'Demand unit',
  'joya.rules.extraCount': 'How many extra people',
  'joya.rules.per': 'One person per',
  'joya.rules.perHint': 'e.g. 30 = one person per 30 diners. The result is rounded up.',
  'joya.rules.steps': 'Steps',
  'joya.rules.stepsHint': 'Each row: "above" (demand) and a headcount. The highest step passed decides.',
  'joya.rules.above': 'Above',
  'joya.rules.addStep': 'step',
  'joya.rules.scopeLocation': 'Applies to location',
  'joya.rules.scopeShift': 'Applies to shift',
  'joya.rules.scopeDays': 'Applies to days',
  'joya.rules.daysHint': 'Nothing chosen = all days.',
  'joya.rules.roleStart': 'Role start (optional)',
  'joya.rules.roleEnd': 'Role end (optional)',
  'joya.rules.mandatoryLabel': 'Mandatory — a restaurant manager cannot go below it',
  'joya.rules.active': 'Active',
  'joya.rules.newShift': 'New shift',
  'joya.rules.editShift': 'Edit shift',
  'joya.rules.shiftCode': 'Code',
  'joya.rules.codeHint': 'Lower-case English letters, digits and _ (e.g. morning).',
  'joya.rules.shiftName': 'Name',
  'joya.rules.shiftDays': 'Days',
  'joya.rules.hours': 'Hours',
  'joya.rules.pastMidnight': 'An end before the start = past midnight.',
  'joya.rules.baselineIntro': 'How many people were really staffed before this system — an example and a baseline. Used to compare, and for a role with no rule. A change is saved when you leave the field.',
  'joya.rules.code': 'Code',
  'joya.rules.newRole': 'New role',
  'joya.rules.nameHe': 'Name in Hebrew',
  'joya.rules.nameEn': 'Name in English',
  'joya.rules.sort': 'Display order',

  // ---- labor
  'joya.labor.sub': 'Sales, worked hours and the labor cost as the Allegro admin computes it.',
  'joya.labor.last7': 'Last 7 days',
  'joya.labor.last30': 'Last 30 days',
  'joya.labor.lastMonth': 'Last month',
  'joya.labor.howTitle': 'How is this calculated?',
  'joya.labor.howGross': 'Gross wage is what the employee earns before deductions. Total employer cost also includes what the employer pays on top of the gross (pension, national insurance and more) — it is higher.',
  'joya.labor.howKnown': 'The labor cost comes from the Allegro admin and uses its payroll rules: hours after the break rule at 100% / 125% / 150% × the role\'s wage, only the completion (השלמה) for tip-based roles (no wage line, no tip), and monthly salaries. "Payslip gross" = wages + travel + bonus from the payslip. A month without a saved payroll is built by the admin from the Tabit reports, like a new payroll (not saved, it can still change). Hours with no wage in the admin are not priced: they are listed.',
  'joya.labor.noPayroll': 'Wages and labor cost need payroll access.',
  'joya.labor.sales': 'Sales',
  'joya.labor.salesDaysMissing_one': '1 day without sales in the period (closed)',
  'joya.labor.salesDaysMissing_other': '{count} days without sales in the period (closed)',
  'joya.labor.hours': 'Worked hours',
  'joya.labor.rowsMissingHours_one': '1 attendance row has no clock-in/out — not counted',
  'joya.labor.rowsMissingHours_other': '{count} attendance rows have no clock-in/out — not counted',
  'joya.labor.salesPerHour': 'Sales per labor hour',
  'joya.labor.laborPct': 'Labor cost as % of sales',
  'joya.labor.costTitle': 'Labor cost (payroll rules)',
  'joya.labor.laborCost': 'Labor cost',
  'joya.labor.payslipGross': 'Payslip gross',
  'joya.labor.payslipPct': 'Payslip gross as % of sales',
  'joya.labor.payroll.saved': '— saved payroll',
  'joya.labor.payroll.tabit': '— from Tabit, not saved yet',
  'joya.labor.payroll.none': '— no payroll',
  'joya.labor.hoursWithoutWage': '{hours} hours have no wage in the admin ({count} people), so the cost is too low:',
  'joya.labor.incomplete': '{pct}% of the hours have no wage — this is not the real labor cost.',
  'joya.labor.notInEmployees': 'not in the employees table',
  'joya.labor.knownBadge': 'Allegro admin',
  'joya.labor.noEmployerLines': 'Allegro has no employer cost — only the gross wage is known.',
  'joya.labor.noKnown': 'No labor cost: the Allegro admin has no payroll and no Tabit report for this period.',
  'joya.labor.pvaTitle': 'Planned vs worked hours (approved plans)',
  'joya.labor.pvaNone': 'No approved staffing plans in this period.',

  // ---- payroll
  'joya.payroll.banner': 'These checks help prepare payroll. Final payroll approval is done by a person in the payroll system — nothing here approves or pays.',
  'joya.payroll.month': 'Month',
  'joya.payroll.tabIssues': 'Issues to check',
  'joya.payroll.tabLines': 'Payroll lines',
  'joya.payroll.run': 'Run checks',
  'joya.payroll.runFor': 'Checks will run for:',
  'joya.payroll.result': '{rows} attendance rows checked · {found} found · {created} new · {closed} closed (no longer found).',
  'joya.payroll.notCompared': 'Payroll hours were not compared (no payroll access).',
  'joya.payroll.noIssues': 'No issues found for this month.',
  'joya.payroll.employee': 'Employee',
  'joya.payroll.rowCount': 'Rows',
  'joya.payroll.attendanceHours': 'Hours in attendance',
  'joya.payroll.payrollHours': 'Hours in payroll',
  'joya.payroll.difference': 'Difference (hours)',
  'joya.payroll.corrected': 'corrected',
  'joya.payroll.mapId': 'Map this id to an employee →',
  'joya.payroll.kind.MISSING_CLOCK_OUT': 'Missing clock-out',
  'joya.payroll.kind.MISSING_CLOCK_IN': 'Missing clock-in',
  'joya.payroll.kind.DUPLICATE': 'Duplicate row',
  'joya.payroll.kind.OVERLAP': 'Overlapping hours',
  'joya.payroll.kind.UNMATCHED_EMPLOYEE': 'Unknown employee id',
  'joya.payroll.kind.HOURS_MISMATCH': 'Payroll hours differ from attendance',
  'joya.payroll.kind.NO_ATTENDANCE': 'Payroll without attendance',
  'joya.payroll.kind.LONG_SHIFT': 'Very long shift',
  'joya.payroll.kindHelp.MISSING_CLOCK_OUT': 'The employee clocked in and no clock-out was recorded. The hours are not counted until corrected.',
  'joya.payroll.kindHelp.MISSING_CLOCK_IN': 'No clock-in was recorded. The hours are not counted until corrected.',
  'joya.payroll.kindHelp.DUPLICATE': 'The same row appears twice. One of them should be left out.',
  'joya.payroll.kindHelp.OVERLAP': 'The same employee has two rows with overlapping hours.',
  'joya.payroll.kindHelp.UNMATCHED_EMPLOYEE': 'The id in the file belongs to no employee. Matching is by id, not by name.',
  'joya.payroll.kindHelp.HOURS_MISMATCH': 'The total hours in the payroll lines differ from the total hours in attendance.',
  'joya.payroll.kindHelp.NO_ATTENDANCE': 'The employee has payroll lines this month, but no attendance.',
  'joya.payroll.kindHelp.LONG_SHIFT': 'A shift longer than {limit} hours — maybe a wrong clock-out.',
  'joya.payroll.act.SET_TIMES': 'Correct times',
  'joya.payroll.act.EXCLUDE': 'Leave row out',
  'joya.payroll.act.ACCEPTED': 'Correct as it is',
  'joya.payroll.act.DISMISSED': 'Not a problem',
  'joya.payroll.act.OPEN': 'Reopen',
  'joya.payroll.clockIn': 'Clock-in',
  'joya.payroll.clockOut': 'Clock-out',
  'joya.payroll.excludeHelp': 'The row will not be counted in hours. The original row stays saved.',
  'joya.payroll.noteRequired': 'Note (required)',
  'joya.payroll.noteHint': 'What was checked and who confirmed it. e.g. "confirmed with the shift manager".',
  'joya.payroll.rawKept': 'The original value from the file is not changed — the correction is saved separately, with your name and the date.',
  'joya.payroll.totals': 'Month totals',
  'joya.payroll.other': 'Other',
  'joya.payroll.linesNoAmount_one': '1 line without an amount',
  'joya.payroll.linesNoAmount_other': '{count} lines without an amount',
  'joya.payroll.noLines': 'No payroll lines for this month.',
  'joya.payroll.costType.GROSS_WAGE': 'gross',
  'joya.payroll.costType.EMPLOYER_COST': 'employer cost',
  'joya.payroll.costType.OTHER': 'other',
};
